import { CellModel, ColumnSource, renderers, RequestFilters, RowSource } from "@omegagrid/grid";
import { msg } from "@omegagrid/localize";
import { ColorTypes } from "@omegagrid/core";
import { GridEditorAdapter, GridEditorOptions, RequestParamsOrder, RowData, ExportType, helpers } from "@reporting/rp-app-host";
import { Module } from "@reporting/rp-types/accounting";
import rp from "@reporting/rp-app-host";
import { Query } from "@reporting/rp-types/ext";

const DEFAULT_FIELDS = ['id_custom_resource', 'name', 'module'];
const DEFAULT_ORDER: RequestParamsOrder = [['name', 'asc']];

export class FileGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(private idProject: number) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;

		const modules = (await rp.ms('accounting').get<Module[]>(`modules`))
			.filter(m => m.type == 'data');

		const moduleColors = modules.reduce<Record<string, string>>((acc, item) =>
			Object.assign(acc, {[item.module]: item.color}), {});

		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 2,
			content: [{
				action: 'delete',
				icon: 'trash',
				color: ColorTypes.Red,
				title: msg('Delete')
			}, {
				action: 'duplicate',
				icon: 'copy',
				color: ColorTypes.Yellow,
				title: msg('Duplicate')
			}],
			filter: false
		}, {
			data: 'id_custom_resource',
			header: '#',
			t: 'n',
			z: '0',
			e: false,
			w: 80
		}, {
			data: 'name',
			header: msg('Name'),
			t: 't',
			e: true,
			w: 200
		}, {
			data: 'module',
			header: msg('Module'),
			t: 's',
			content: modules.map(m => ({k: m.module, v: m.name, icon: {icon: 'cube', color: m.color}})),
			renderer: (div: HTMLDivElement, cell: CellModel) => {
				renderers.DropdownRenderer(div, cell);
				if (cell.hasValue) div.insertAdjacentHTML('afterbegin', `
					<og-fa-icon icon="cube" style="color: ${moduleColors[cell.value as string]}"></og-fa-icon>
				`);
				return div;
			},
			e: true,
			w: 100
		}, {
			data: 'sync',
			header: msg('Sync'),
			t: 'b',
			e: true,
			w: 80
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		return (await rp.ms('extensions').get<Query[]>(`resources`, this.createRequestParams(filters, {
			fields: DEFAULT_FIELDS,
			where: {id_custom_page: this.idProject},
			order: DEFAULT_ORDER,
			count: this.pageSize
		}))).map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: this.pageSize,
			refreshAfterSave: true,
			// exportTypes : ['csv', 'xlsx'],
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({_state: row.state, _index: row.index}, row.data));
		await rp.ms('extensions').post(`resources`, data);
	}

	async export(type: ExportType) {
		if (type == 'xlsx') return await super.export(type);
		await rp.ms('extensions').download('exportThreads', {
			fields: DEFAULT_FIELDS,
			order: DEFAULT_ORDER,
			fileName: helpers.createExportFilename(type),
			csvParams: {header: true, delimiter: ',', encoding: 'utf-8'},
		});
	}

}
